import React from 'react';
import HeartFilledIcon from '@tradera/blueprint/theme/icons2/heart-fill.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';

const WishListButton = ({
    className,
    disabled,
    iconClassName,
    onClick,
    showText,
    toggled
}) => {
    const { t } = useTranslator();
    const text = toggled
        ? t('itemCard_savedToWishlist')
        : t('itemCard_saveToWishlist');

    const iconClasses = [
        'icon icon-stroke-white',
        toggled ? 'icon-danger' : '',
        showText ? 'icon-before' : '',
        iconClassName || ''
    ].join(' ');

    const combinedClassName = [
        'btn',
        showText ? 'btn-icon-fixed' : 'btn-round',
        className || ''
    ].join(' ');

    return (
        <button
            aria-label={text}
            className={combinedClassName}
            disabled={disabled}
            onClick={onClick}>
            {toggled ? (
                <HeartFilledIcon className={iconClasses} />
            ) : (
                <>
                    <HeartFilledIcon
                        className={`${iconClasses} icon-dark-50 hover-hide`}
                    />
                    <HeartFilledIcon
                        className={`${iconClasses} icon-danger hover-show`}
                    />
                </>
            )}
            {showText && <span>{text}</span>}
        </button>
    );
};

export default WishListButton;
